import { render, staticRenderFns } from "./SelectFrom.vue?vue&type=template&id=09315833&"
import script from "./SelectFrom.vue?vue&type=script&lang=js&"
export * from "./SelectFrom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\RobertWiberg\\source\\repos\\server-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('09315833')) {
      api.createRecord('09315833', component.options)
    } else {
      api.reload('09315833', component.options)
    }
    module.hot.accept("./SelectFrom.vue?vue&type=template&id=09315833&", function () {
      api.rerender('09315833', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Compose/SelectFrom.vue"
export default component.exports